import './instrumentation';
import styled from '@emotion/styled';
import { AdapterDayjs } from '@mui/x-date-pickers-pro/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers-pro/LocalizationProvider';
import { LicenseInfo } from '@mui/x-license';
import * as Sentry from '@sentry/react';
import { StrictMode } from 'react';
import * as ReactDOM from 'react-dom/client';
import { IntlProvider } from 'react-intl';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';

import { HarnessFFProvider, SplitFFProvider, store } from '@verantos-dev/app-state-base';
import { AuthProvider } from '@verantos-dev/core-auth';
import { AppThemeProvider, GlobalStyles } from '@verantos-dev/shared-styles';
import { Messages } from '@verantos-dev/types-common';

import App from './app/app';
import BackgroundImage from './assets/images/verantos-background.png';
import { ErrorFallback } from './components/ErrorFallback';
import locale_en from './locale/en';

import './assets/fonts/roboto.css';
import '@fortawesome/fontawesome-free/css/all.min.css';
import 'dayjs/locale/en';

// Mui X Pro License
LicenseInfo.setLicenseKey(
  '9a8f54655b7c5bcdc3a97fae833c9963Tz05OTg1NixFPTE3NjAyOTY2NzYwMDAsUz1wcm8sTE09c3Vic2NyaXB0aW9uLFBWPVEzLTIwMjQsS1Y9Mg==' // pragma: allowlist secret
);

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
const language = navigator.language.split(/[-_]/)[0]; // language without region code

const messages: Messages = {
  en: locale_en,
};

const AppBackground = styled.div`
  background-image: url(${BackgroundImage});
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  min-height: 100vh;
  height: 100%;
  width: 100%;
`;

root.render(
  <StrictMode>
    <Sentry.ErrorBoundary fallback={<ErrorFallback />}>
      <GlobalStyles />
      <AppBackground>
        <Provider store={store}>
          <IntlProvider locale={language} messages={messages[language]} defaultLocale="en">
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <AuthProvider>
                <HarnessFFProvider>
                  <SplitFFProvider>
                    <AppThemeProvider>
                      <BrowserRouter>
                        <App />
                      </BrowserRouter>
                    </AppThemeProvider>
                  </SplitFFProvider>
                </HarnessFFProvider>
              </AuthProvider>
            </LocalizationProvider>
          </IntlProvider>
        </Provider>
      </AppBackground>
    </Sentry.ErrorBoundary>
  </StrictMode>
);
